import { ReactComponent as InfoBookIcon } from './icons/custom/info_book.svg';
import { ReactComponent as InfoBubbleIcon } from './icons/custom/info_bubble.svg';
import { ReactComponent as InfoCasinoIcon } from './icons/custom/info_casino.svg';
import { ReactComponent as InfoChatIcon } from './icons/custom/info_chat.svg';
import { ReactComponent as InfoComedyIcon } from './icons/custom/info_comedy.svg';
import { ReactComponent as InfoDirectionsIcon } from './icons/custom/info_directions.svg';
import { ReactComponent as InfoHandshakeIcon } from './icons/custom/info_handshake.svg';
import { ReactComponent as InfoHelpIcon } from './icons/custom/info_help.svg';
import { ReactComponent as InfoLibraryIcon } from './icons/custom/info_library.svg';

import { ReactComponent as MemberShipDiamondIcon } from './icons/custom/membership_diamond.svg';
import { ReactComponent as MemberShipEventsIcon } from './icons/custom/membership_events.svg';
import { ReactComponent as MemberShipPremiumdIcon } from './icons/custom/membership_premium.svg';
import { ReactComponent as MemberShipSocialIcon } from './icons/custom/membership_social.svg';
import { ReactComponent as MemberShipStartIcon } from './icons/custom/membership_star.svg';

import { ReactComponent as ShopApparelIcon } from './icons/custom/shop_apparel.svg';
import { ReactComponent as ShopMallIcon } from './icons/custom/shop_mall.svg';
import { ReactComponent as ShopStoreIcon } from './icons/custom/shop_store.svg';
import { ReactComponent as ShopVectorIcon } from './icons/custom/shop_vector.svg';

import { ReactComponent as TicketActivityIcon } from './icons/custom/ticket_activity.svg';
import { ReactComponent as TicketNumberIcon } from './icons/custom/ticket_number.svg';
import { ReactComponent as TicketSportIcon } from './icons/custom/ticket_sport.svg';

import { ReactComponent as HomeIcon } from './icons/standard/menu_home.svg';
import { ReactComponent as FantasyIcon } from './icons/standard/menu_fantasy.svg';
import { ReactComponent as FotballplayIcon } from './icons/standard/menu_fotbollplay.svg';
import { ReactComponent as GamedayIcon } from './icons/standard/menu_gameday.svg';
import { ReactComponent as MoreIcon } from './icons/standard/menu_more.svg';
import { ReactComponent as NewsIcon } from './icons/standard/menu_news.svg';
import { ReactComponent as StandingsIcon } from './icons/standard/menu_standings.svg';
import { ReactComponent as TeamsIcon } from './icons/standard/menu_teams.svg';
import { ReactComponent as CloseIcon } from './icons/standard/menu_close.svg';
import { ReactComponent as UnibetIcon } from './icons/standard/menu_unibet.svg';
import { ReactComponent as MatchesIcon } from './icons/standard/menu_matches.svg';
import { ReactComponent as StatsIcon } from './icons/standard/menu_stats.svg';

export const bottomBarIconsMapStandard = {
  Home: HomeIcon,
  Fantasy: FantasyIcon,
  Fotballplay: FotballplayIcon,
  Gameday: GamedayIcon,
  Unibet: UnibetIcon,
  Matches: MatchesIcon,
  More: MoreIcon,
  News: NewsIcon,
  Standings: StandingsIcon,
  Teams: TeamsIcon,
  Stats: StatsIcon,
  Close: CloseIcon,
};

export const bottomBarIconsMapCustom = {
  TicketActivity: TicketActivityIcon,
  TicketNumber: TicketNumberIcon,
  TicketSport: TicketSportIcon,
  InfoBook: InfoBookIcon,
  InfoBubble: InfoBubbleIcon,
  InfoCasino: InfoCasinoIcon,
  InfoChat: InfoChatIcon,
  InfoComedy: InfoComedyIcon,
  InfoDirections: InfoDirectionsIcon,
  InfoHandshake: InfoHandshakeIcon,
  InfoHelp: InfoHelpIcon,
  InfoLibrary: InfoLibraryIcon,
  MemberShipDiamond: MemberShipDiamondIcon,
  MemberShipEvents: MemberShipEventsIcon,
  MemberShipPremiumd: MemberShipPremiumdIcon,
  MemberShipSocial: MemberShipSocialIcon,
  MemberShipStart: MemberShipStartIcon,
  ShopApparel: ShopApparelIcon,
  ShopMall: ShopMallIcon,
  ShopStore: ShopStoreIcon,
  ShopVector: ShopVectorIcon,
};

export const bottomBarIconsMap = {
  ...bottomBarIconsMapStandard,
  ...bottomBarIconsMapCustom,
};
